import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// withCredentials=true so the httpOnly auth cookie is sent on every request.
// Note: cookie is set by the server on login/register/google. The frontend
// never reads or stores the JWT in JS — full cookie-only auth.
export const apiClient = axios.create({ baseURL: API, withCredentials: true });

// WebSocket — relies entirely on the same httpOnly cookie (same-origin).
// Server reads it from `websocket.cookies['fnl_token']`.
export const wsUrl = () => {
  const wsBase = BACKEND_URL.replace(/^http/, 'ws');
  return `${wsBase}/api/ws`;
};
